import createDebug from 'debug';
import { AuthService } from '../services/auth/auth.service';
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';

const debug = createDebug('authInterceptor');

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);

  // Skip external requests — only attach tokens to our own API.
  // Resolve against <base href> so a configured basePath (e.g.
  // /apexDesigner) still matches: API requests go to `${basePath}/api/...`.
  const apiBase = new URL('api/', document.baseURI).href;
  if (!new URL(req.url, document.baseURI).href.startsWith(apiBase)) {
    return next(req);
  }

  // authService.accessToken emits the current OIDC access token.
  return (
    authService.accessToken
      // .pipe() chains an operation onto that emitted value.
      .pipe(
        // switchMap() waits for the token, then runs this function with it.
        switchMap((token) => {
          const headers: Record<string, string> = {};

          if (token) {
            debug('token', token);
            headers['Authorization'] = `Bearer ${token}`;
          }

          // Add impersonation header if set in sessionStorage
          const impersonateEmail = sessionStorage.getItem('impersonateEmail');
          if (impersonateEmail) {
            debug('impersonating user', impersonateEmail);
            headers['X-Impersonate-Email'] = impersonateEmail;
          }

          if (Object.keys(headers).length > 0) {
            return next(req.clone({ setHeaders: headers }));
          }

          debug('no token');
          return next(req);
        }),
      )
  );
};
